import * as tslib_1 from "tslib";
import { HttpClient, HttpParams } from '@angular/common/http';
import { InterfaceService } from '@app/interfaces';
import { Observable } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var ApiService = /** @class */ (function (_super) {
    tslib_1.__extends(ApiService, _super);
    function ApiService(http) {
        var _this = _super.call(this) || this;
        _this.http = http;
        return _this;
    }
    ApiService.prototype.createPrivateApplication = function (applicationName, description) {
        var payload = {
            applicationName: applicationName,
            description: description
        };
        return this.http.post(this.getApiUrl('createPrivateApplications'), payload);
    };
    ApiService.prototype.getPrivateApplications = function (page, limit, nameContains) {
        var queryParams = {
            page: page,
            limit: limit,
            name_contains: nameContains
        };
        return this.http.get(this.getApiUrl('listPrivateApplications', queryParams));
    };
    ApiService.prototype.getApplicationScopes = function (privateApplicationId, showScopes, nameContains) {
        var queryParams = {
            privateApplicationId: privateApplicationId
        };
        if (nameContains) {
            queryParams.name_contains = nameContains;
        }
        if (showScopes) {
            queryParams.showScopes = showScopes;
        }
        return this.http.get(this.getApiUrl('getApplicationScopes', queryParams));
    };
    ApiService.prototype.getApplicationScopesListing = function (privateApplicationId, name_contains, page, limit) {
        var queryParams = {
            privateApplicationId: privateApplicationId,
        };
        if (name_contains) {
            queryParams.name_contains = name_contains;
        }
        if (page) {
            queryParams.page = page;
        }
        if (limit) {
            queryParams.limit = limit;
        }
        return this.http.get(this.getApiUrl('getApplicationScopes', queryParams));
    };
    ApiService.prototype.updateApplicationScopes = function (privateApplicationId, scopes) {
        var payload = {
            // applicationId: privateApplicationId,
            scopes: scopes
        };
        return this.http.put(this.getApiUrl('updateApplicationScopes') + "?applicationId=" + privateApplicationId, payload);
    };
    ApiService.prototype.updateApplicationWebhook = function (privateApplicationId, setupWebhooks, webhookUrl, webhookFailureEmail, scopes) {
        if (scopes === void 0) { scopes = []; }
        var payload = {
            setupWebhooks: setupWebhooks,
            webhookUrl: webhookUrl,
            webhookFailureEmail: webhookFailureEmail,
            scopes: scopes
        };
        return this.http.put(this.getApiUrl('updateApplicationWebhook') + "?privateApplicationId=" + privateApplicationId, payload);
    };
    ApiService.prototype.getApplicationKeys = function (privateApplicationId, webhookId) {
        var queryParams = {
            privateApplicationId: privateApplicationId,
            webhookId: webhookId
        };
        return this.http.get(this.getApiUrl('getApplicationKeys', queryParams));
    };
    ApiService.prototype.deletePrivateApplication = function (privateApplicationId) {
        return this.http.delete(this.getApiUrl('deletePrivateApplcation') + "?privateApplicationId=" + privateApplicationId);
    };
    ApiService.prototype.deleteApplicationScopes = function (privateApplicationId, scope) {
        return this.http.request('delete', this.getApiUrl('deleteApplicationScopes') + "?privateApplicationId=" + privateApplicationId, {
            body: {
                scope: scope
            }
        });
    };
    ApiService.prototype.getApplicationWebhook = function (privateApplicationId) {
        var queryParams = {
            privateApplicationId: privateApplicationId
        };
        return this.http.get(this.getApiUrl('getApplicationWebhook', queryParams));
    };
    ApiService.prototype.getWebhookScopes = function (privateApplicationId, showScopes) {
        var queryParams = {
            privateApplicationId: privateApplicationId
        };
        if (showScopes) {
            queryParams.showScopes = showScopes;
        }
        return this.http.get(this.getApiUrl('getWebhookScopes', queryParams));
    };
    ApiService.prototype.updatePrivateApplication = function (privateApplicationId, applicationName, description) {
        var payload = {
            applicationName: applicationName,
            description: description
        };
        return this.http.put(this.getApiUrl('editPrivateApplication') + "?privateApplicationId=" + privateApplicationId, payload);
    };
    ApiService.prototype.getPrivateApplicationById = function (privateApplicationId) {
        var params = new HttpParams().set('privateApplicationId', privateApplicationId.toString());
        return this.http.get(this.getApiUrl('listPrivateApplicationById'), { params: params });
    };
    ApiService.prototype.regenerateApplicationKey = function (privateApplicationId) {
        var queryParams = {
            privateApplicationId: privateApplicationId
        };
        return this.http.put(this.getApiUrl('regenerateApplicationKey', queryParams), {});
    };
    ApiService.prototype.regenerateWebhookSecret = function (privateApplicationId) {
        var queryParams = {
            privateApplicationId: privateApplicationId
        };
        return this.http.put(this.getApiUrl('regenerateWebhookSecret', queryParams), {});
    };
    ApiService.prototype.getApiLogs = function (params) {
        var httpParams = new HttpParams();
        // Required query parameter
        httpParams = httpParams.set('privateApplicationId', params.privateApplicationId.toString());
        // Optional query parameters
        if (params.limit !== undefined) {
            httpParams = httpParams.set('limit', params.limit.toString());
        }
        if (params.page !== undefined) {
            httpParams = httpParams.set('page', params.page.toString());
        }
        if (params.searchText) {
            httpParams = httpParams.set('searchText', params.searchText);
        }
        // Filters go in the request body
        var body = {};
        if (params.filters.length) {
            body.filters = params.filters;
        }
        return this.http.post(this.getApiUrl('getApiLogs'), body, { params: httpParams });
    };
    ApiService.prototype.getApilogFilterAction = function () {
        var url = 'getApilogFilterAction';
        return this.http.get(this.getApiUrl(url));
    };
    ApiService.prototype.getWebhookLogs = function (params) {
        var httpParams = new HttpParams();
        // Required query parameter
        httpParams = httpParams.set('privateApplicationId', params.privateApplicationId.toString());
        // Optional query parameters
        if (params.limit !== undefined) {
            httpParams = httpParams.set('limit', params.limit.toString());
        }
        if (params.page !== undefined) {
            httpParams = httpParams.set('page', params.page.toString());
        }
        if (params.searchText) {
            httpParams = httpParams.set('searchText', params.searchText);
        }
        // Filters go in the request body
        var body = {};
        if (params.filters.length) {
            body.filters = params.filters;
        }
        return this.http.post(this.getApiUrl('getWebhookLogs'), body, { params: httpParams });
    };
    ApiService.prototype.getWebhooklogFilterAction = function () {
        var url = 'getWebhooklogFilterAction';
        return this.http.get(this.getApiUrl(url));
    };
    ApiService.prototype.getApiLogDetails = function (apiLogId, privateApplicationId) {
        var queryParams = {
            apiLogId: apiLogId,
            privateApplicationId: privateApplicationId
        };
        return this.http.get(this.getApiUrl('getApiLogDetails', queryParams));
    };
    ApiService.prototype.getWebhookLogDetails = function (webhookLogId, privateApplicationId) {
        var queryParams = {
            webhookLogId: webhookLogId,
            privateApplicationId: privateApplicationId
        };
        return this.http.get(this.getApiUrl('getWebhookLogDetails', queryParams));
    };
    ApiService.prototype.getApplicationOverviewGraph = function (privateApplicationId) {
        var queryParams = {
            privateApplicationId: privateApplicationId
        };
        return this.http.get(this.getApiUrl('getApplicationOverviewGraph', queryParams));
    };
    ApiService.prototype.getRecentErrors = function (privateApplicationId) {
        var queryParams = {
            privateApplicationId: privateApplicationId
        };
        return this.http.get(this.getApiUrl('getRecentErrors', queryParams));
    };
    ApiService.prototype.resendWebhookCall = function (webhookLogId, privateApplicationId) {
        var queryParams = {
            webhookLogId: webhookLogId,
            privateApplicationId: privateApplicationId
        };
        return this.http.post(this.getApiUrl('resendWebhookCall', queryParams), {});
    };
    ApiService.prototype.validateApplicationOwner = function (privateApplicationId) {
        var queryParams = {
            privateApplicationId: privateApplicationId
        };
        return this.http.get(this.getApiUrl('validateApplicationOwner', queryParams));
    };
    ApiService.prototype.takeApplicationOwnership = function (privateApplicationId, newUserId) {
        var body = {
            privateApplicationId: privateApplicationId,
            newUserId: newUserId
        };
        return this.http.post(this.getApiUrl('takeApplicationOwnership'), body);
    };
    ApiService.prototype.getPermissions = function () {
        return this.http.get(this.getApiUrl('get_access_details'));
    };
    ApiService.prototype.checkPausedWebhook = function (privateApplicationId) {
        var queryParams = {
            privateApplicationId: privateApplicationId
        };
        return this.http.get(this.getApiUrl('checkPausedWebhook', queryParams));
    };
    ApiService.prototype.revertPausedWebhook = function (privateApplicationId) {
        var queryParams = {
            privateApplicationId: privateApplicationId
        };
        return this.http.post(this.getApiUrl('revertPausedWebhook', queryParams), {});
    };
    ApiService.ngInjectableDef = i0.defineInjectable({ factory: function ApiService_Factory() { return new ApiService(i0.inject(i1.HttpClient)); }, token: ApiService, providedIn: "root" });
    return ApiService;
}(InterfaceService));
export { ApiService };
